import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdControlProgramsSuspense } from "api/generated/users/users";

export function useControlProgramsForUserQuery(userId: number) {
    return useGetUsersUserIdControlProgramsSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
